var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"input"},[_c('input',_vm._b({attrs:{"placeholder":_vm.label},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.update($event)}}},'input',_vm.$props,false)),(_vm.appendIcon)?_c('img',{staticClass:"append-icon",attrs:{"width":"18px","src":_vm.appendIcon}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }